import { SelectedCategory } from '@/features/pos/components/ProductCatalog/parts/CategoryBar/types'
import { useEffect, useRef } from 'react'

export const usePrevSelectedCategoryRef = (selectedId?: string, selectedSubcategoryId?: string) => {
    const prevSelectedRef = useRef<SelectedCategory>(undefined)

    useEffect(() => {
        if (!selectedId) {
            prevSelectedRef.current = undefined

            return
        }

        prevSelectedRef.current = {
            id: selectedId,
            subcategoryId: selectedSubcategoryId,
        }
    }, [selectedId, selectedSubcategoryId])

    return prevSelectedRef
}
